import { render, staticRenderFns } from "./DepartureNewsCard.vue?vue&type=template&id=33373da6&scoped=true&"
import script from "./DepartureNewsCard.vue?vue&type=script&lang=js&"
export * from "./DepartureNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./DepartureNewsCard.vue?vue&type=style&index=0&id=33373da6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33373da6",
  null
  
)

export default component.exports